import { Delete } from "@wix/wix-ui-icons-common";
import React, { useContext } from "react";
import { RicosContext } from "./../../../../ricos-context/index.js";
import { ToolbarButton } from "./../../../../_shared/toolbar-button/toolbar-button.js";
const DeleteButton = ({ toolbarItem, dataHook }) => {
  const { t } = useContext(RicosContext) || {};
  const onClick = toolbarItem.commands.click;
  return /* @__PURE__ */ React.createElement(
    ToolbarButton,
    {
      prefix: Delete,
      onClick: () => onClick ? onClick() : toolbarItem.commands.delete(),
      dataHook,
      tooltip: t("DeleteButton_Tooltip"),
      tabIndex: toolbarItem.presentation.tabIndex
    }
  );
};
var DeleteButton_default = DeleteButton;
export {
  DeleteButton_default as default
};
//# sourceMappingURL=DeleteButton.js.map
